export enum IssueTypeEnum {
    accessibility = 'accessibility',
    qaBrokenLink = 'qaBrokenLink',
    qaBrokenImage = 'qaBrokenImage',
    misspellings = 'misspellings',
    potentialMisspellings = 'potentialMisspellings',
    dataPrivacy = 'dataPrivacy',
}
